/**
 * การแปลภาษาไทย
 * Thai Translation
 */

const thTHTranslations = {
  app: {
    title: 'เครื่องมือจัดการการทำงานล่วงเวลา',
    subtitle: 'ระบบจัดการการทำงานล่วงเวลา',
    description: 'เครื่องมือบันทึกการทำงานล่วงเวลาและจัดการวันหยุดชดเชยแบบมืออาชีพ'
  },

  // วันที่และเวลา
  dateTime: {
    invalidDate: 'วันที่ไม่ถูกต้อง',
    formatError: 'รูปแบบวันที่ผิดพลาด'
  },

  common: {
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    delete: 'ลบ',
    edit: 'แก้ไข',
    copy: 'คัดลอก',
    close: 'ปิด',
    loading: 'กำลังโหลด...',
    success: 'สำเร็จ',
    error: 'ข้อผิดพลาด',
    warning: 'คำเตือน',
    info: 'ข้อมูล',
    yes: 'ใช่',
    no: 'ไม่',
    ok: 'ตกลง',
    back: 'กลับ',
    next: 'ถัดไป',
    previous: 'ก่อนหน้า',
    submit: 'ส่ง',
    reset: 'รีเซ็ต',
    clear: 'ล้าง',
    search: 'ค้นหา',
    filter: 'กรอง',
    sort: 'เรียง',
    export: 'ส่งออก',
    import: 'นำเข้า',
    settings: 'การตั้งค่า',
    help: 'ช่วยเหลือ',
    about: 'เกี่ยวกับ'
  },
  
  time: {
    startTime: 'เวลาเริ่มต้น',
    endTime: 'เวลาสิ้นสุด',
    duration: 'ระยะเวลา',
    totalTime: 'เวลารวม',
    remainingTime: 'เวลาที่เหลือ',
    usedTime: 'เวลาที่ใช้',
    availableTime: 'เวลาที่ใช้ได้',
    hours: 'ชั่วโมง',
    minutes: 'นาที',
    days: 'วัน',
    today: 'วันนี้',
    yesterday: 'เมื่อวาน',
    thisWeek: 'สัปดาห์นี้',
    thisMonth: 'เดือนนี้',
    thisYear: 'ปีนี้'
  },
  
  overtime: {
    title: 'บันทึกการทำงานล่วงเวลา',
    record: 'บันทึกการทำงานล่วงเวลา',
    startTime: 'เวลาเริ่มทำงานล่วงเวลา',
    endTime: 'เวลาสิ้นสุดการทำงานล่วงเวลา',
    duration: 'ระยะเวลาทำงานล่วงเวลา',
    remaining: 'เวลาหยุดชดเชยที่เหลือ',
    total: 'เวลาทำงานล่วงเวลารวม',
    list: 'รายการบันทึกการทำงานล่วงเวลา',
    details: 'บันทึกรายละเอียด',
    consumption: 'บันทึกการใช้',
    edit: 'แก้ไขบันทึกการทำงานล่วงเวลา',
    delete: 'ลบบันทึกการทำงานล่วงเวลา',
    copy: 'คัดลอกบันทึก',
    
    validation: {
      startTimeRequired: 'กรุณาใส่เวลาเริ่มทำงานล่วงเวลา!',
      endTimeRequired: 'กรุณาใส่เวลาสิ้นสุดการทำงานล่วงเวลา!',
      endTimeAfterStart: 'เวลาสิ้นสุดการทำงานล่วงเวลาต้องหลังจากเวลาเริ่มต้น!'
    },
    
    stats: {
      totalHours: 'ปีนี้คุณทำงานล่วงเวลา {{hours}} ชั่วโมง',
      remainingHours: 'เวลาหยุดชดเชยที่เหลือ: {{overtimeHours}}+{{annualLeaveHours}} ชั่วโมง'
    }
  },
  
  rest: {
    title: 'บันทึกการหยุดชดเชย',
    record: 'ขอหยุดชดเชย',
    startTime: 'เวลาเริ่มหยุดชดเชย',
    endTime: 'เวลาสิ้นสุดการหยุดชดเชย',
    duration: 'ระยะเวลาหยุดชดเชย',
    type: 'ประเภทการหยุดชดเชย',
    compTime: 'หยุดชดเชย',
    list: 'รายการบันทึกการหยุดชดเชย',
    edit: 'แก้ไขบันทึกการหยุดชดเชย',
    delete: 'ลบบันทึกการหยุดชดเชย',
    
    validation: {
      startTimeRequired: 'กรุณาใส่เวลาเริ่มต้นและสิ้นสุดการหยุดชดเชย!',
      endTimeRequired: 'กรุณาใส่เวลาสิ้นสุดการหยุดชดเชย!',
      endTimeAfterStart: 'เวลาสิ้นสุดการหยุดชดเชยต้องหลังจากเวลาเริ่มต้น!',
      insufficientTime: 'เวลาที่เหลือไม่เพียงพอสำหรับการขอหยุดชดเชยนี้!',
      insufficientOvertimeTime: 'เวลาทำงานล่วงเวลาไม่เพียงพอที่จะเพิ่มเวลาหยุดชดเชย!'
    }
  },
  
  annualLeave: {
    title: 'การจัดการวันลาประจำปี',
    totalDays: 'จำนวนวันลาประจำปีทั้งหมด',
    usedHours: 'ชั่วโมงที่ใช้',
    remainingHours: 'ชั่วโมงที่เหลือ',
    record: 'บันทึกวันลาประจำปี',
    set: 'ตั้งค่าวันลาประจำปี',
    edit: 'แก้ไขบันทึกวันลาประจำปี',
    delete: 'ลบบันทึกวันลาประจำปี',
    
    settings: {
      title: 'ตั้งค่าวันลาประจำปี',
      totalDaysLabel: 'จำนวนวันลาประจำปีทั้งหมด',
      totalDaysPlaceholder: 'ใส่จำนวนวันลาประจำปีทั้งหมด',
      note: 'หมายเหตุ: วันลาประจำปีคำนวณเป็น 8 ชั่วโมงต่อวัน'
    }
  },
  
  rules: {
    title: 'กฎการคำนวณ',
    overtime: {
      title: 'กฎการคำนวณการทำงานล่วงเวลา',
      description: 'คำนวณตามเวลาต่อเนื่อง รวมเวลาพักกลางวัน',
      example: 'ตัวอย่าง: {{timeRange}} = {{result}}',
      note: 'เวลาทำงานล่วงเวลาคำนวณตามเวลาต่อเนื่องจริง ไม่หักเวลาพักกลางวัน'
    },
    rest: {
      title: 'กฎการคำนวณการหยุดชดเชย',
      description: 'คำนวณตามวันทำงาน หักเวลาพักกลางวัน',
      example: 'ตัวอย่าง: {{timeRange}} = {{result}} ({{note}})',
      note: 'หักเวลาพักกลางวัน 1 ชั่วโมง',
      workingHours: 'เวลาทำงาน: 9:00-18:00 (ยกเว้นเวลาพักกลางวัน 12:00-13:00)'
    },
    annualLeave: {
      title: 'กฎการคำนวณวันลาประจำปี',
      description: 'วันลาประจำปีคำนวณเป็น 8 ชั่วโมงต่อวัน',
      example: 'วันลาประจำปี 1 วัน = 8 ชั่วโมง'
    }
  },
  
  data: {
    save: 'บันทึกข้อมูลในเครื่อง',
    load: 'โหลดข้อมูลสำรอง',
    export: 'ส่งออกข้อมูล',
    import: 'นำเข้าข้อมูล',
    backup: 'สำรองข้อมูล',
    restore: 'คืนค่าข้อมูล',
    clear: 'ล้างข้อมูล',
    
    messages: {
      saveSuccess: 'บันทึกข้อมูลสำเร็จ',
      loadSuccess: 'นำเข้าและอัปเดตข้อมูลสำเร็จ',
      exportSuccess: 'ส่งออกข้อมูลสำเร็จ',
      importSuccess: 'นำเข้าข้อมูลสำเร็จ',
      clearSuccess: 'ล้างข้อมูลสำเร็จ',
      parseError: 'ไม่สามารถแยกวิเคราะห์ไฟล์ที่นำเข้าได้ กรุณาตรวจสอบว่าเป็นรูปแบบที่ถูกต้อง',
      newerDataWarning: 'ข้อมูลที่นำเข้าเก่ากว่าข้อมูลในเครื่อง คุณยังต้องการเขียนทับข้อมูลในเครื่องหรือไม่?',
      cleanupComplete: 'การล้างข้อมูลเสร็จสิ้น ลบบันทึกซ้ำซ้อน {{count}} รายการ'
    }
  },
  
  table: {
    index: 'ดัชนี',
    number: 'ลำดับ',
    type: 'ประเภท',
    startTime: 'เวลาเริ่มต้น',
    endTime: 'เวลาสิ้นสุด',
    duration: 'ระยะเวลา',
    remaining: 'ที่เหลือ',
    remainingTime: 'เวลาหยุดพักที่เหลือ',
    actions: 'การดำเนินการ',
    details: 'บันทึกรายละเอียด',
    expand: 'ขยาย',
    collapse: 'ย่อ',
    noData: 'ไม่มีข้อมูล',
    consumptionRecords: 'บันทึกการพักผ่อน',
    restRequestStartTime: 'เวลาเริ่มต้นการพักผ่อน',
    restRequestEndTime: 'เวลาสิ้นสุดการพักผ่อน',
    actualConsumptionStartTime: 'เวลาเริ่มต้นการใช้จริง',
    actualConsumptionEndTime: 'เวลาสิ้นสุดการใช้จริง',
    deductionTime: 'เวลาหักการพักผ่อน',
    annualLeaveStartTime: 'เวลาเริ่มต้นวันลาประจำปี',
    annualLeaveEndTime: 'เวลาสิ้นสุดวันลาประจำปี',

    pagination: {
      total: 'ทั้งหมด {{total}} รายการ',
      pageSize: 'รายการต่อหน้า',
      items: 'รายการ',
      page: 'หน้า'
    }
  },
  
  consumption: {
    title: 'บันทึกการใช้เวลาหยุดชดเชย',
    restStartTime: 'เวลาเริ่มต้นการขอหยุดชดเชย',
    restEndTime: 'เวลาสิ้นสุดการขอหยุดชดเชย',
    actualStartTime: 'เวลาเริ่มต้นการใช้จริง',
    actualEndTime: 'เวลาสิ้นสุดการใช้จริง',
    deductionTime: 'เวลาหักการหยุดชดเชย',
    type: 'ประเภท',
    
    copyReport: {
      overtimeDeduction: 'หักเวลาทำงานล่วงเวลาที่สอดคล้อง ({{hours}} ชั่วโมง)',
      annualLeaveDeduction: 'หักเวลาวันลาประจำปี ({{hours}} ชั่วโมง)',
      copySuccess: 'คัดลอกไปยังคลิปบอร์ดแล้ว',
      copyFailed: 'การคัดลอกล้มเหลว กรุณาลองใหม่อีกครั้ง'
    }
  },
  
  updateLog: {
    title: 'บันทึกการอัปเดต',
    show: 'แสดงบันทึกการอัปเดต',
    hide: 'ซ่อนบันทึกการอัปเดต',
    version: 'เวอร์ชัน',
    date: 'วันที่',
    content: 'เนื้อหาการอัปเดต'
  },
  
  language: {
    title: 'การตั้งค่าภาษา',
    current: 'ภาษาปัจจุบัน',
    select: 'เลือกภาษา',
    change: 'เปลี่ยนภาษา'
  },
  
  errors: {
    networkError: 'ข้อผิดพลาดเครือข่าย กรุณาตรวจสอบการเชื่อมต่อ',
    serverError: 'ข้อผิดพลาดเซิร์ฟเวอร์ กรุณาลองใหม่ภายหลัง',
    unknownError: 'ข้อผิดพลาดที่ไม่ทราบสาเหตุ กรุณาติดต่อผู้ดูแลระบบ',
    validationError: 'การตรวจสอบข้อมูลล้มเหลว',
    permissionDenied: 'ไม่มีสิทธิ์เข้าถึง',
    notFound: 'ไม่พบข้อมูล',
    timeout: 'หมดเวลาการร้องขอ กรุณาลองใหม่อีกครั้ง'
  },
  
  confirmDialog: {
    deleteTitle: 'ยืนยันการลบ',
    deleteMessage: 'คุณแน่ใจหรือไม่ว่าต้องการลบบันทึกนี้?',
    clearTitle: 'ยืนยันการล้าง',
    cleanupMessage: 'คุณแน่ใจหรือไม่ว่าต้องการล้างข้อมูลซ้ำซ้อน? การดำเนินการนี้ไม่สามารถยกเลิกได้',
    overwriteTitle: 'ยืนยันการเขียนทับ',
    overwriteMessage: 'ข้อมูลในเครื่องจะถูกเขียนทับ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?',
    deleteRestMessage: 'คุณแน่ใจหรือไม่ว่าต้องการลบบันทึกการพักผ่อนนี้?',
    deleteAnnualLeaveMessage: 'คุณแน่ใจหรือไม่ว่าต้องการลบบันทึกวันลาประจำปีนี้?'
  },

  // บันทึกที่เกี่ยวข้อง
  records: {
    overtimeRecords: 'บันทึกการทำงานล่วงเวลา',
    restRecords: 'บันทึกการพักผ่อน',
    annualLeaveRecords: 'บันทึกวันลาประจำปี',
    restType: 'การพักผ่อน',
    annualLeaveType: 'วันลาประจำปี',
    annualLeave: 'วันลาประจำปี',
    rest: 'การพักผ่อน',
    overtime: 'การทำงานล่วงเวลา'
  },

  // การแบ่งหน้า
  pagination: {
    previous: 'ก่อนหน้า',
    next: 'ถัดไป',
    pageInfo: 'หน้า {{current}} จาก {{total}}',
    itemsPerPage: '{{count}} รายการ/หน้า'
  },



  // ฟังก์ชันการคัดลอก
  copy: {
    deductOvertimeTotal: 'การพักผ่อนทดแทนการทำงานล่วงเวลา, หักเวลาทำงานล่วงเวลา ({{hours}} ชั่วโมง)',
    deductAnnualLeaveTotal: 'หักเวลาวันลาประจำปี ({{hours}} ชั่วโมง)',
    annualLeaveTitle: 'วันลาประจำปี:',
    errorPrefix: 'ไม่สามารถคัดลอกข้อความได้: '
  },

  // สถิติ
  stats: {
    totalOvertime: 'เวลาทำงานล่วงเวลารวม',
    availableOvertime: 'เวลาทำงานล่วงเวลาที่ใช้ได้',
    remainingAnnualLeave: 'เวลาวันลาประจำปีที่เหลือ',
    totalRest: 'เวลาพักผ่อนรวม'
  },

  // การดำเนินการ
  actions: {
    recordOvertime: 'บันทึกการทำงานล่วงเวลา',
    addOvertimeTime: 'เพิ่มเวลาทำงานล่วงเวลา',
    requestRest: 'ขอการพักผ่อน',
    useOvertimeTime: 'ใช้เวลาทำงานล่วงเวลา',
    setAnnualLeave: 'ตั้งค่าวันลาประจำปี',
    configureAnnualLeaveDays: 'กำหนดจำนวนวันลาประจำปี',
    saveData: 'บันทึกข้อมูล',
    exportData: 'ส่งออกข้อมูล',
    importData: 'นำเข้าข้อมูล',
    cleanData: 'ล้างข้อมูล'
  },

  // ข้อความ
  messages: {
    overtimeAdded: 'เพิ่มบันทึกการทำงานล่วงเวลาแล้ว',
    restAdded: 'เพิ่มบันทึกการพักผ่อนแล้ว',
    overtimeDeleted: 'ลบบันทึกการทำงานล่วงเวลาแล้ว',
    restDeleted: 'ลบบันทึกการพักผ่อนแล้ว',
    dataSaved: 'บันทึกข้อมูลแล้ว',
    dataLoaded: 'โหลดข้อมูลแล้ว',
    dataImported: 'นำเข้าข้อมูลแล้ว',
    dataExported: 'ส่งออกข้อมูลแล้ว',
    noLocalData: 'ไม่พบข้อมูลในเครื่อง ใช้ข้อมูลเริ่มต้น',
    cleanupComplete: 'ล้างข้อมูลเสร็จสิ้น ลบบันทึกซ้ำซ้อน {{count}} รายการ',
    overtimeRecordAdded: 'เพิ่มบันทึกการทำงานล่วงเวลาสำเร็จ!',
    restRequestSubmitted: 'ส่งคำขอพักผ่อนสำเร็จ!',
    pleaseCompleteTimeInfo: 'กรุณากรอกข้อมูลเวลาให้ครบถ้วน',
    overtimeRecordUpdated: 'อัปเดตบันทึกการทำงานล่วงเวลาสำเร็จ!',
    restRecordUpdated: 'อัปเดตบันทึกการพักผ่อนสำเร็จ!',
    annualLeaveRecordUpdated: 'อัปเดตบันทึกวันลาประจำปีสำเร็จ!',
    copiedToClipboard: 'คัดลอกไปยังคลิปบอร์ดแล้ว',
    copyFailed: 'การคัดลอกล้มเหลว กรุณาลองใหม่อีกครั้ง'
  },

  // โมดอล
  modals: {
    recordOvertimeTitle: 'บันทึกการทำงานล่วงเวลา',
    requestRestTitle: 'ขอการพักผ่อน',
    setAnnualLeaveTitle: '🏖️ ตั้งค่าจำนวนวันลาประจำปี',
    editOvertimeTitle: 'แก้ไขบันทึกการทำงานล่วงเวลา',
    editRestTitle: 'แก้ไขบันทึกการพักผ่อน',
    editAnnualLeaveTitle: 'แก้ไขบันทึกวันลาประจำปี',
    recordOvertimeTimeTitle: '⏱️ บันทึกเวลาทำงานล่วงเวลา',
    requestRestTimeTitle: '😴 ขอเวลาพักผ่อน'
  },

  // ฟอร์ม
  forms: {
    currentAnnualLeave: 'วันลาประจำปีปัจจุบัน:',
    remainingTime: 'เวลาที่เหลือ:',
    customDays: 'จำนวนวันที่กำหนดเอง:',
    enterDays: 'ใส่จำนวนวัน',
    noAnnualLeave: 'ไม่มีวันลาประจำปี',
    annualLeaveStartTime: 'เวลาเริ่มต้นวันลาประจำปี:',
    annualLeaveEndTime: 'เวลาสิ้นสุดวันลาประจำปี:',
    overtimeStartTime: 'เวลาเริ่มต้นการทำงานล่วงเวลา:',
    overtimeEndTime: 'เวลาสิ้นสุดการทำงานล่วงเวลา:'
  },

  // ธีม
  theme: {
    toggle: 'เปลี่ยนธีม',
    modern: 'สไตล์โมเดิร์น',
    retro: 'สไตล์เรโทร',
    sketch: 'สไตล์สเก็ตช์',
    damaged: 'สไตล์เสียหาย',
    switchToModern: 'เปลี่ยนเป็นสไตล์โมเดิร์น',
    switchToRetro: 'เปลี่ยนเป็นสไตล์เรโทร',
    switchToSketch: 'เปลี่ยนเป็นสไตล์สเก็ตช์',
    switchToDamaged: 'เปลี่ยนเป็นสไตล์เสียหาย'
  }
};

export default thTHTranslations;
